import { Component, OnInit,ElementRef, ViewChild } from '@angular/core';
import { LocalizationService } from './shared/localization/localization.service';
import { AppInsightsService } from './shared/services/app-config/app-insights.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  @ViewChild('twilioRingtone', { static: true })
      public ringtone!: ElementRef;

    constructor(private appInsightsService: AppInsightsService)
    {this.ringtone?.nativeElement?.play();}
  async ngOnInit() {
  }
}
